import {
    LegacyFilmPlayerBaseInfoContent,
    LegacyVideoPlayerBaseInfoContent,
    MovieStreamFragment,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { getPreferredTracks } from '../../movie-player/utils/get-preferred-tracks';

import { getFilmWatchParams } from './get-film-watch-params';
import { getFilmOnlineStreams } from './get-film-online-streams';

export function getFilmPreferredTracks(
    filmOrVideo:
        | LegacyFilmPlayerBaseInfoContent
        | LegacyVideoPlayerBaseInfoContent
        | undefined
        | null,
    getDefaultAudio?: (streams: MovieStreamFragment) => string | undefined
) {
    const watchParams = getFilmWatchParams(filmOrVideo);
    const onlineStreams = getFilmOnlineStreams(filmOrVideo);

    return getPreferredTracks({
        watchParams,
        onlineStreams,
        getDefaultAudio,
    });
}
